<template>
  <div style="position: relative">
    <div class="page_header">
      <span class="page_title">{{ $t("vehicletrack.page_title") }}</span>
      <el-form :inline="true" :size="size" style="flex: 1; text-align: right">
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker
            v-model="queryTime"
            type="datetimerange"
            :range-separator="$t('time.to')"
            :start-placeholder="$t('time.startTimeHolder')"
            :end-placeholder="$t('time.endTimeHolder')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('vehicletrack.stopTimes')">
          <el-input-number
            v-model="ParkDuration"
            style="width: 100px"
            :min="1"
            :max="10"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 80px"
            type="primary"
            @click="onQueryClick"
            :loading="loading"
            >{{ $t("public.query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="page_container">
      <div
        style="width: 100%; height: calc(100vh - 210px); background-color: #fff"
      >
        <KingLongMap mapId="klmap_track" ref="map" />
      </div>
    </div>
    <div
      v-if="isShowResult"
      style="
        position: absolute;
        background-color: #fff;
        right: 16px;
        top: 60px;
        left: 16px;
        z-index: 999;
        background-color: rgba(256, 256, 256, 0.6);
      "
    >
      <TrackSlider
        v-model="current_slider"
        style="width: 100%"
        ref="trackslider"
        :max="totalCount"
      />
    </div>

    <div
      v-if="isShowResult"
      style="
        position: absolute;
        background-color: transparent;
        left: 0px;
        width: 460px;
        bottom: 0px;
        z-index: 999;
      "
    >
      <!--动态变化，表格和详细，详细可以返回-->
      <el-card
        class="box-card"
        style="opacity: 1; background-color: rgba(256, 256, 256, 0.6)"
      >
        <div v-if="false" style="padding-bottom: 16px">
          <div style="padding: 8px">返回</div>
          <!-- 详情,车牌号，上报时间，速度，acc状态，转速，位置描述 -->
          <el-row>
            <el-col :span="24" style="margin-top: 16px">
              <kl-info
                title="车牌:"
                bold
                value="BUS226"
                icon="icon-icon_jiankongdanchuang_weizhi"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="margin-top: 16px">
              <kl-info
                title="上报时间:"
                bold
                value="2023-12-12 14:20:13"
                icon="icon-icon_jiankongdanchuang_weizhi"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-for="(item, index) in monitor_items"
              :key="index"
              style="margin-top: 16px"
            >
              <kl-info
                :title="item.title"
                bold
                :type="item.color"
                :value="item.value"
                :icon="item.icon"
            /></el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="margin-top: 16px">
              <kl-info
                title="位置描述："
                bold
                value="厦门市集美区海沧大桥进岛方向3公里"
                icon="icon-icon_jiankongdanchuang_weizhi"
              />
            </el-col>
          </el-row>
        </div>
        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane
              :label="$t('vehicletrack.gpstrack')"
              name="first"
            ></el-tab-pane>
            <el-tab-pane
              :label="$t('vehicletrack.stoppoint')"
              name="second"
            ></el-tab-pane>
            <el-tab-pane
              :label="$t('vehicletrack.baddriver')"
              name="three"
            ></el-tab-pane>
            <!-- <el-tab-pane label="超速路段" name="four"></el-tab-pane> -->
          </el-tabs>
          <div v-show="activeName == 'first'" style="height: 240px">
            <el-table
              :data="gpsTableData"
              style="width: 100%; overflow: auto; height: 204px"
              size="mini"
              highlight-current-row
              ref="singleTable"
            >
              <el-table-column
                prop="ID"
                align="center"
                :label="$t('public.index')"
              >
              </el-table-column>
              <el-table-column
                prop="GpsDateTime"
                align="center"
                :label="$t('vehicletrack.upTime')"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="Speed"
                align="center"
                :label="$t('vehicletrack.speed')"
              >
              </el-table-column>
              <!-- <el-table-column prop="name" align="center" label="查看"  width="60" >
                        </el-table-column> -->
            </el-table>

            <kl-pagination
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              :current-page.sync="current_page"
            >
            </kl-pagination>
          </div>
          <div v-show="activeName == 'second'" style="height: 240px">
            <el-table
              :data="stopTableData"
              style="width: 100%; overflow: auto; height: 204px"
              size="mini"
             
              ref="stopTable"
            >
              <el-table-column
                prop="BeginTime"
                align="center"
                :label="$t('time.startTimeHolder')"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="EndTime"
                align="center"
                :label="$t('time.endTimeHolder')"
                width="160"
              >
              </el-table-column>
              <el-table-column
                prop="ParkDuration"
                align="center"
                :label="$t('vehicletrack.stopTimes')"
              >
              </el-table-column>
            </el-table>

            <kl-pagination
              :total="totalStopCount"
              :page-size="pageSize"
              @current-change="handleStopCurrentChange"
              :current-page.sync="current_stop_page"
            >
            </kl-pagination>
          </div>
          <div v-if="activeName == 'three'" style="height: 240px">
            <el-table
              :data="eventTableData"
              style="width: 100%; overflow: auto; height: 204px"
              size="mini"
              highlight-current-row
              ref="stopTable"
            >
              <el-table-column
                prop="TheDate"
                align="center"
                :label="$t('public.date')"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="EventType"
                align="center"
                :label="$t('public.event')"
              >
                <template slot-scope="scope">
                  {{ $t("eventype." + scope.row.EventType) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="BTime"
                align="center"
                :label="$t('time.startTimeHolder')"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="EventTETimeype"
                align="center"
                :label="$t('time.endTimeHolder')"
               width="120"
              >
              </el-table-column>
              <el-table-column
                prop="Duration"
                align="center"
                :label="$t('vehicletrack.duration')"
                width="120"
              >
              </el-table-column>
            </el-table>

            <kl-pagination
              :total="totalEventCount"
              :page-size="pageSize"
              @current-change="handleEventCurrentChange"
              :current-page.sync="current_event_page"
            >
            </kl-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <vehicle_info ref="vehicleinfo" />
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap";
import vehicle_info from "@/views/vmonitor/locateVehicle/components/vehicleinfo";
import { mapState } from "vuex";
import { getIconByDirection } from "@/utils/VehicleHelper";
import TrackSlider from "@/components/TrackSlider";
import settings from "@/settings";
export default {
    name:"vehicleTrack",
  components: {
    KingLongMap,
    vehicle_info,
    TrackSlider,
  },
  computed: {
    ...mapState({
      //   opened: state => state.app.sidebar.opened,
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
      size: (state) => state.app.size,
    }),
  },
  data() {
    return {
      loading: false,
      queryTime: [], //默认当天，查询时间
      ParkDuration: 1, //停车时长
      GpsData: [], //gps数据
      current_index: -1, //当前轨迹点位置
      current_page: 0, //当前轨迹点位置
      current_slider: 0, //当前播放位置
      gpsTableData: [], //当前GPS显示数据

      current_marker: undefined,
      totalCount: 0,
      current_stop_page: 0,
      current_event_page: 0,
      pageSize: 5,
      StopData: [],
      EventData: [],
      isShowResult: false,
      stopTableData: [], //当前停车显示数据
      eventTableData: [], //当前停车显示数据
      totalStopCount: 0,
      totalEventCount: 0,
      activeName: "first",
      gpsinfo: undefined,
      vehicleInfo: undefined,
      monitor_items: [
        {
          icon: "icon-icon_jiankongdanchuang_ACC",
          title: "ACC状态： ",
          value: "开启",
          color: "success",
        },
        {
          icon: "icon-icon_jiankongdanchuang_chesu",
          title: "车速(km/h):",
          value: "146km/h",
          color: "danger",
        },
        {
          icon: "icon-icon_jiankongdanchuang_zhuansu",
          title: "转数(rpm):",
          value: "4700",
          color: "danger",
        },
        {
          icon: "icon-icon_jiankongdanchuang_fangxiang",
          title: "方向：",
          value: "西偏北9°",
          color: "",
        },
      ],
    };
  },

  watch: {
    current_slider() {
      this.current_index = this.current_slider;
      this.updateGpsPos();
    },
    current_stop_page() {
      //计算显示gps数据
      this.stopTableData = [];
      var start = (this.current_stop_page - 1) * this.pageSize;
      var end = start + this.pageSize;
      var data = this.StopData.slice(start, end);
      // console.log(data);
      this.stopTableData = data;
    },
    current_event_page() {
      //计算显示gps数据
      this.eventTableData = [];
      var start = (this.current_event_page - 1) * this.pageSize;
      var end = start + this.pageSize;
      var data = this.EventData.slice(start, end);
      // console.log(data);
      this.eventTableData = data;
    },
    current_page() {
      //计算显示gps数据
      this.gpsTableData = [];
      var start = (this.current_page - 1) * this.pageSize;
      var end = start + this.pageSize;
      var data = this.GpsData.slice(start, end);
      // console.log(data);
      this.gpsTableData = data;
    },

    current_index() {
      //主动更新表格数据
      // this.current_page = Math.floor(this.current_index / this.pageSize) + 1;
      // console.log(this.current_index % this.pageSize)
      // this.$nextTick(() => {
      //     this.$refs.singleTable.setCurrentRow(this.gpsTableData[this.current_index % this.pageSize]);
      // });
    },
  },
  methods: {
    handleCurrentChange(page) {
      //切换了GPS数据列表
      this.current_page = page;
    },
    handleStopCurrentChange(page) {
      this.current_stop_page = page;
    },
    handleEventCurrentChange(page) {
      this.current_event_page = page;
    },
    onQueryClick() {
      //数据查询
      // console.log(this.selectedVehicles);
      //选中车辆
      if (this.selectedVehicles.length == 0) {
        this.$message.warning(this.$t("vehicletrack.selectvehicle"));
        return;
      }
      if (this.selectedVehicles.length > 1) {
        this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
        return;
      }
      if (!this.queryTime || this.queryTime.length == 0) {
        this.$message.warning(this.$t("time.selectQueryTime"));
        return;
      }
      this.vehicleInfo = this.selectedVehicles[0];

      //清楚其他的内容
      this.reset();

      var begin = this.moment(this.queryTime[0]);
      var end = this.moment(this.queryTime[1]);

      this.loading = true;
      //获取选中车辆，数据查询，赋值
      this.$api
        .QueryVehicleTrackInfo({
          VehicleId: this.vehicleInfo.nodeValue.toString(), // "100844",
          StartTime: begin.format("YYYY-MM-DD HH:mm:ss"), //"2023-08-15 07:00:00",
          EndTime: end.format("YYYY-MM-DD HH:mm:ss"), // "2023-08-15 08:00:41",
          Flag: 2,
          ParkDuration: this.ParkDuration,
          LanguageId: 1,
        })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            if (res.data.GpsData && res.data.GpsData.length > 0) {
              //GPS数据

              this.GpsData = res.data.GpsData;
              this.StopData = res.data.StopData;
              this.EventData = res.data.EventData;

              this.gpsTableData = this.GpsData.slice(0, this.pageSize);
              this.eventTableData = this.EventData.slice(0, this.pageSize);
              this.stopTableData = this.StopData.slice(0, this.pageSize);
              this.isShowResult = true;
              this.initGpsData();
              this.initStopData();
              this.initEventData();
            } else {
              this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
            }
          }
          this.loading = false;
        });
    },
    initStopData() {
      this.totalStopCount = this.StopData.length;
      this.current_stop_page = 1;
    },
    initEventData() {
      this.totalEventCount = this.EventData.length;
      this.current_event_page = 1;
    },
    initGpsData() {
      var bd_gps = [];

      this.GpsData.forEach((item) => {
        bd_gps.push({ lng: item.Longitude, lat: item.Latitude });
      });

      this.$refs.map.addPolyline("gps_line", "gps_line", bd_gps, 5, "#2A7AFF");

      //切换轨迹点
      this.totalCount = this.GpsData.length;
      this.current_index = 0;
      this.current_page = 1;
      this.$nextTick(() => {
        this.$refs.trackslider.togglePlay();
      });
    },

    updateGpsPos() {
      //更新位置

      var _this = this;
      // console.log(_this.current_marker);

      if (_this.$refs.map) _this.$refs.map.removeMarkerById("v_last_gps");
      _this.current_marker = undefined;

      this.gpsinfo = _this.GpsData[_this.current_index];

      if (this.gpsinfo && _this.$refs.map) {
        var iconUrl = getIconByDirection(this.gpsinfo.Direction);
        _this.$refs.map.addMarker(
          "v_last_gps",
          this.vehicleInfo.vehicleName,
          this.gpsinfo.Longitude,
          this.gpsinfo.Latitude,
          iconUrl,
          () => {
            _this.showGpsInfo();
          }
        );

        if (_this.current_index == 0)
          _this.$refs.map.setCenter(
            this.gpsinfo.Longitude,
            this.gpsinfo.Latitude
          );
      }
    },
    showGpsInfo() {
      if (this.$refs.vehicleinfo)
        this.$refs.vehicleinfo.show(
          this.vehicleInfo.vehicleName,
          this.gpsinfo.AccState,
          this.gpsinfo.Speed,
          this.gpsinfo.EngineRev,
          this.gpsinfo.Direction,
          this.gpsinfo.GpsMileage,
          this.gpsinfo.Position,
          this.gpsinfo.GpsDateTime
        );
    },
    reset() {
      if (this.timer_gps) clearInterval(this.timer_gps);
      this.$refs.map.clearAll();
      this.GpsData = [];
      this.StopData = [];
      this.EventData = [];
    },
    init() {
      this.queryTime = [];
      var now = new Date();
      this.queryTime.push(
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      );
      this.queryTime.push(new Date());
    },
  },
  mounted() {
      const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.init();
  },
};
</script>
<style scoped>
.el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
</style>
